import { createSlice } from '@reduxjs/toolkit'

const initialCouponsState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: [],
	profiles: [],
	couponForEdit: undefined,
	lastError: null,
}
export const callTypes = {
	list: 'list',
	action: 'action',
}

export const couponsSlice = createSlice({
	name: 'coupons',
	initialState: initialCouponsState,
	reducers: {
		catchError: (state, action) => {
			state.error = `${action.payload.error}`
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false
			} else {
				state.actionsLoading = false
			}
		},
		startCall: (state, action) => {
			state.error = null
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true
			} else {
				state.actionsLoading = true
			}
		},
		// getCouponById
		couponFetched: (state, action) => {
			state.actionsLoading = false
			state.couponForEdit = action.payload.couponForEdit
			state.error = null
		},
		// findCoupons
		couponsFetched: (state, action) => {
			const { totalCount, entities } = action.payload
			state.listLoading = false
			state.error = null
			state.entities = entities
			state.totalCount = totalCount
		},
		// createCoupon
		couponCreated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			state.entities.push(action.payload.data)
		},
		// updateCoupon
		couponUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.coupon.id) {
					return action.payload.coupon
				}
				return entity
			})
		},
		couponApproved: (state, action) => {
			console.log(action.payload)
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload) {
					entity.approved = true
					return entity
				}
				return entity
			})
		},
		// deleteCoupon
		couponDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id
			)
		},
		// deleteCoupons
		couponsDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => !action.payload.ids.includes(el.id)
			)
		},
		// couponsUpdateState
		couponsStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { ids, status } = action.payload
			state.entities = state.entities.map((entity) => {
				if (ids.findIndex((id) => id === entity.id) > -1) {
					entity.status = status
				}
				return entity
			})
		},
		profilesFetched: (state, action) => {
			state.listLoading = false
			state.error = null
			state.profiles = action.payload
		},
	},
})
